'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FLOATING_ALERT_DEFAULT_TIMEOUT = exports.FLOATING_ALERT_DEFAULT_TIMEOUT = 4000;